<template>
  <div class="base">
    <!--<m-header-top></m-header-top>-->
    <m-header></m-header>
    <slot></slot>
    <m-footer></m-footer>
  </div>
</template>


<script>
  import MHeader from '@/components/layouts/MHeader.vue'
  import MHeaderTop from '@/components/layouts/MHeaderTop.vue'
  import MFooter from '@/components/layouts/MFooter.vue'
  import MContactUs from '@/components/landings/MContactUs'

  export default {
    components: {
      MHeader,
      MFooter,
      MHeaderTop,
      MContactUs
    }
  }
</script>


<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/layouts/MBase.vue